import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star"]
  static values = { current: { type: Number, default: 0 } }

  preview(event) {
    const button = event.currentTarget
    const svg = button.querySelector("svg")
    const starNum = parseInt(svg.dataset.star)
    this.highlight(starNum)
  }

  reset() {
    this.highlight(this.currentValue)
  }

  highlight(count) {
    this.starTargets.forEach((button) => {
      const svg = button.querySelector("svg")
      const path = svg.querySelector("path")
      const starNum = parseInt(svg.dataset.star)

      if (starNum <= count) {
        svg.setAttribute("fill", "currentColor")
        path.classList.add("text-yellow-400")
        path.classList.remove("text-gray-300", "dark:text-gray-600")
      } else {
        svg.setAttribute("fill", "none")
        path.classList.remove("text-yellow-400")
        path.classList.add("text-gray-300", "dark:text-gray-600")
      }
    })
  }
}
